import tableCellClasses from "@mui/material/TableCell/tableCellClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiTableHeadTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                [`.${tableCellClasses.head}[class][class][class]`]: typographyResponsive(dt, "body2.medium"),
            },
        },
    };
};
